"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _color = require("./color.js");

function _default(a, b) {
  var i = (0, _color.hue)(+a, +b);
  return function (t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-interpolate/src/hue.js
// module id = 6857
// module chunks = 0